import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { selectEnvironment, selectUser } from "../store/selector";
import { trackPendoEvent } from "../utils/pendoUtils";

export const useGeneralReportTrackingEvent = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const user = useSelector(selectUser);
  const account = useSelector(selectEnvironment);

  const trackEvent = (eventName, extraData = {}) => {
    try {
      trackPendoEvent(dispatch, eventName, {
        user: user?.email,
        account,
        ...extraData
      });
    } catch (errorText) {
      console.error(t("messages.errors.pendo_tracking_error"), errorText);
    }
  };

  const trackDropdownSelection = (filterType, selectedValue, componentType = "dropdown") => {
    trackEvent("date_type_option_selected", {
      filter_type: filterType,
      selected_value: selectedValue,
      component_type: componentType,
      element_id: `${filterType}-${selectedValue}`
    });
  };

  return { trackDropdownSelection };
};
